import { render, staticRenderFns } from "./bomList.vue?vue&type=template&id=7049f940&"
import script from "./bomList.vue?vue&type=script&lang=js&"
export * from "./bomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports